module.exports = __webpack_public_path__ + "static/media/zoleLose_500_1000.4068933e.png";